import * as React from "react";

function SvgVan(props: React.SVGProps<SVGSVGElement>): React.ReactElement {
  const { fill } = props;
  return (
    <svg width={13} height={13} viewBox="0 0 13 13" fill="none" {...props}>
      <g clipPath="url(#clip0)">
        <path
          d="M12.9534 6.53443C12.4199 6.06227 11.7026 5.75936 10.9071 5.71307C10.6007 5.04316 10.0714 4.44747 9.38257 3.97198C9.37707 3.96836 9.37216 3.96504 9.36681 3.96113C9.05912 3.75051 8.71918 3.56463 8.35421 3.40565C8.07979 3.30367 7.86107 3.2636 7.70846 3.25H7.67461H2.73647H0.725019C0.530601 3.25 0.372925 3.41968 0.372925 3.629V4.8175V6.44474V8.8689C0.372925 9.07807 0.530601 9.24761 0.725019 9.24761H1.19457C1.19457 8.44983 1.84133 7.80321 2.63897 7.80321C3.43704 7.80321 4.08351 8.44997 4.08351 9.24761H7.568H7.67447H9.3331C9.3331 8.44983 9.97986 7.80321 10.7776 7.80321C11.5754 7.80321 12.2219 8.44997 12.2219 9.24761H13.3729C13.3729 8.58899 13.3729 7.84429 13.3729 7.47542C13.3731 7.07313 13.1548 6.74866 12.9534 6.53443ZM6.19203 5.70352V3.5898H7.84024C9.03062 4.02218 9.957 4.78047 10.3981 5.70338H6.19203V5.70352Z"
          fill={fill ?? "black"}
        />
        <path
          d="M2.63896 8.13448C2.02431 8.13448 1.52597 8.63267 1.52597 9.24746C1.52597 9.8624 2.02431 10.3606 2.63896 10.3606C3.25389 10.3606 3.75209 9.8624 3.75209 9.24746C3.75209 8.63282 3.25389 8.13448 2.63896 8.13448ZM2.63896 9.79846C2.33475 9.79846 2.08811 9.55168 2.08811 9.24746C2.08811 8.94311 2.33475 8.69647 2.63896 8.69647C2.94332 8.69647 3.18981 8.94311 3.18981 9.24746C3.18967 9.55168 2.94317 9.79846 2.63896 9.79846Z"
          fill={fill ?? "black"}
        />
        <path
          d="M10.7778 8.13448C10.1627 8.13448 9.66467 8.63267 9.66467 9.24746C9.66467 9.8624 10.1627 10.3606 10.7778 10.3606C11.3925 10.3606 11.8908 9.8624 11.8908 9.24746C11.8908 8.63282 11.3925 8.13448 10.7778 8.13448ZM10.7778 9.79846C10.4734 9.79846 10.2268 9.55168 10.2268 9.24746C10.2268 8.94311 10.4734 8.69647 10.7778 8.69647C11.082 8.69647 11.3287 8.94311 11.3287 9.24746C11.3285 9.55168 11.0819 9.79846 10.7778 9.79846Z"
          fill={fill ?? "black"}
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width={13} height={13} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgVan;
